import { TranslateService } from '@ngx-translate/core';

export interface PermissionRationale {
  title: string;
  message: string;
  positiveAction: string;
  negativeAction: string;
}

export function translatePermissionRationale(
  translateService: TranslateService,
): PermissionRationale {
  return {
    title: translateService.instant('movacarpro_tracking_permission_title'),
    message: translateService.instant(
      'movacarpro_tracking_permission_rationale',
    ),
    positiveAction: translateService.instant(
      'movacarpro_tracking_permission_enable',
    ),
    negativeAction: translateService.instant(
      'movacarpro_tracking_permission_cancel',
    ),
  };
}
